/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ChannelTypePayload } from '../models/channel-type-payload';
import { NotificationChannel } from '../models/notification-channel';
import { TestNotificationRequest } from '../models/test-notification-request';
import { NotificationTagPayload } from '../models/notification-tag-payload';
import { NotificationTypeResponse } from '../models/notification-type-response';
import { Subscription } from '../models/subscription';
import { TagDataModel } from '../models/tag-data-model';
import { NotificationTagsForTypeResult } from '../models/notification-tags-for-type-result';

/**
 * Ui Notification Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiNotificationControllerService extends __BaseService {
  static readonly getAllChannelTypesUsingGETPath =
    '/cc-ui/v1/notification/channelTypes';
  static readonly getAllChannelsUsingGETPath =
    '/cc-ui/v1/notification/channels';
  static readonly createNotificationChannelUsingPOSTPath =
    '/cc-ui/v1/notification/channels';
  static readonly testNotificationChannelUsingPOSTPath =
    '/cc-ui/v1/notification/channels/test';
  static readonly getChannelUsingGETPath =
    '/cc-ui/v1/notification/channels/{channelId}';
  static readonly editNotificationChannelUsingPUTPath =
    '/cc-ui/v1/notification/channels/{channelId}';
  static readonly deleteNotificationChannelUsingDELETEPath =
    '/cc-ui/v1/notification/channels/{channelId}';
  static readonly getAllNotificationTagsUsingGETPath =
    '/cc-ui/v1/notification/notificationTags';
  static readonly getSubscriptionAttributesUsingGETPath =
    '/cc-ui/v1/notification/notificationType/{notificationType}/attributes';
  static readonly getAllNotificationTypesUsingGETPath =
    '/cc-ui/v1/notification/notificationTypes';
  static readonly getAllSubscriptionsUsingGETPath =
    '/cc-ui/v1/notification/subscriptions';
  static readonly createSubscriptionUsingPOSTPath =
    '/cc-ui/v1/notification/subscriptions';
  static readonly getSubscriptionUsingGETPath =
    '/cc-ui/v1/notification/subscriptions/{subscriptionId}';
  static readonly editSubscriptionUsingPUTPath =
    '/cc-ui/v1/notification/subscriptions/{subscriptionId}';
  static readonly deleteSubscriptionUsingDELETEPath =
    '/cc-ui/v1/notification/subscriptions/{subscriptionId}';
  static readonly getFiltersForSubscriptionsUsingPOSTPath =
    '/cc-ui/v1/notification/{notificationType}/tag/{tagName}/values/';
  static readonly getNotificationTagsForNotificationTypeUsingGETPath =
    '/cc-ui/v1/notification/{notificationType}/tags';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * getAllChannelTypes
   * @return OK
   */
  getAllChannelTypesUsingGETResponse(): __Observable<
    __StrictHttpResponse<Array<ChannelTypePayload>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/notification/channelTypes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ChannelTypePayload>>;
      }),
    );
  }
  /**
   * getAllChannelTypes
   * @return OK
   */
  getAllChannelTypesUsingGET(): __Observable<Array<ChannelTypePayload>> {
    return this.getAllChannelTypesUsingGETResponse().pipe(
      __map((_r) => _r.body as Array<ChannelTypePayload>),
    );
  }

  /**
   * getAllChannels
   * @return OK
   */
  getAllChannelsUsingGETResponse(): __Observable<
    __StrictHttpResponse<Array<NotificationChannel>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/notification/channels`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<NotificationChannel>>;
      }),
    );
  }
  /**
   * getAllChannels
   * @return OK
   */
  getAllChannelsUsingGET(): __Observable<Array<NotificationChannel>> {
    return this.getAllChannelsUsingGETResponse().pipe(
      __map((_r) => _r.body as Array<NotificationChannel>),
    );
  }

  /**
   * createNotificationChannel
   * @param nc nc
   * @return OK
   */
  createNotificationChannelUsingPOSTResponse(
    nc: NotificationChannel,
  ): __Observable<__StrictHttpResponse<Array<NotificationChannel>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = nc;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/notification/channels`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<NotificationChannel>>;
      }),
    );
  }
  /**
   * createNotificationChannel
   * @param nc nc
   * @return OK
   */
  createNotificationChannelUsingPOST(
    nc: NotificationChannel,
  ): __Observable<Array<NotificationChannel>> {
    return this.createNotificationChannelUsingPOSTResponse(nc).pipe(
      __map((_r) => _r.body as Array<NotificationChannel>),
    );
  }

  /**
   * testNotificationChannel
   * @param testNotificationRequest testNotificationRequest
   * @return OK
   */
  testNotificationChannelUsingPOSTResponse(
    testNotificationRequest: TestNotificationRequest,
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = testNotificationRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/notification/channels/test`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === 'true',
        }) as __StrictHttpResponse<boolean>;
      }),
    );
  }
  /**
   * testNotificationChannel
   * @param testNotificationRequest testNotificationRequest
   * @return OK
   */
  testNotificationChannelUsingPOST(
    testNotificationRequest: TestNotificationRequest,
  ): __Observable<boolean> {
    return this.testNotificationChannelUsingPOSTResponse(
      testNotificationRequest,
    ).pipe(__map((_r) => _r.body as boolean));
  }

  /**
   * getChannel
   * @param channelId channelId
   * @return OK
   */
  getChannelUsingGETResponse(
    channelId: string,
  ): __Observable<__StrictHttpResponse<NotificationChannel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/notification/channels/${encodeURIComponent(
          String(channelId),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<NotificationChannel>;
      }),
    );
  }
  /**
   * getChannel
   * @param channelId channelId
   * @return OK
   */
  getChannelUsingGET(channelId: string): __Observable<NotificationChannel> {
    return this.getChannelUsingGETResponse(channelId).pipe(
      __map((_r) => _r.body as NotificationChannel),
    );
  }

  /**
   * editNotificationChannel
   * @param params The `UiNotificationControllerService.EditNotificationChannelUsingPUTParams` containing the following parameters:
   *
   * - `nc`: nc
   *
   * - `channelId`: channelId
   *
   * @return OK
   */
  editNotificationChannelUsingPUTResponse(
    params: UiNotificationControllerService.EditNotificationChannelUsingPUTParams,
  ): __Observable<__StrictHttpResponse<Array<NotificationChannel>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.nc;

    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/notification/channels/${encodeURIComponent(
          String(params.channelId),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<NotificationChannel>>;
      }),
    );
  }
  /**
   * editNotificationChannel
   * @param params The `UiNotificationControllerService.EditNotificationChannelUsingPUTParams` containing the following parameters:
   *
   * - `nc`: nc
   *
   * - `channelId`: channelId
   *
   * @return OK
   */
  editNotificationChannelUsingPUT(
    params: UiNotificationControllerService.EditNotificationChannelUsingPUTParams,
  ): __Observable<Array<NotificationChannel>> {
    return this.editNotificationChannelUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as Array<NotificationChannel>),
    );
  }

  /**
   * deleteNotificationChannel
   * @param channelId channelId
   * @return OK
   */
  deleteNotificationChannelUsingDELETEResponse(
    channelId: string,
  ): __Observable<__StrictHttpResponse<Array<NotificationChannel>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl +
        `/cc-ui/v1/notification/channels/${encodeURIComponent(
          String(channelId),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<NotificationChannel>>;
      }),
    );
  }
  /**
   * deleteNotificationChannel
   * @param channelId channelId
   * @return OK
   */
  deleteNotificationChannelUsingDELETE(
    channelId: string,
  ): __Observable<Array<NotificationChannel>> {
    return this.deleteNotificationChannelUsingDELETEResponse(channelId).pipe(
      __map((_r) => _r.body as Array<NotificationChannel>),
    );
  }

  /**
   * getAllNotificationTags
   * @return OK
   */
  getAllNotificationTagsUsingGETResponse(): __Observable<
    __StrictHttpResponse<Array<NotificationTagPayload>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/notification/notificationTags`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<NotificationTagPayload>>;
      }),
    );
  }
  /**
   * getAllNotificationTags
   * @return OK
   */
  getAllNotificationTagsUsingGET(): __Observable<
    Array<NotificationTagPayload>
  > {
    return this.getAllNotificationTagsUsingGETResponse().pipe(
      __map((_r) => _r.body as Array<NotificationTagPayload>),
    );
  }

  /**
   * getSubscriptionAttributes
   * @param notificationType notificationType
   * @return OK
   */
  getSubscriptionAttributesUsingGETResponse(
    notificationType:
      | 'DEPLOYMENT_STATUS_UPDATE'
      | 'APP_DEPLOYMENT'
      | 'QASUITE_SANITY'
      | 'DR_RESULT'
      | 'STACK_SIGNOFF'
      | 'ALERT'
      | 'TEST'
      | 'APPLICATION_DEPLOYMENT_COMPLETE'
      | 'ENVIRONMENT_CREATE'
      | 'ENVIRONMENT_DELETE'
      | 'ENVIRONMENT_LAUNCH'
      | 'ENVIRONMENT_DESTROY'
      | 'ENVIRONMENT_CONFIGURE',
  ): __Observable<__StrictHttpResponse<Array<string>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/notification/notificationType/${encodeURIComponent(
          String(notificationType),
        )}/attributes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<string>>;
      }),
    );
  }
  /**
   * getSubscriptionAttributes
   * @param notificationType notificationType
   * @return OK
   */
  getSubscriptionAttributesUsingGET(
    notificationType:
      | 'DEPLOYMENT_STATUS_UPDATE'
      | 'APP_DEPLOYMENT'
      | 'QASUITE_SANITY'
      | 'DR_RESULT'
      | 'STACK_SIGNOFF'
      | 'ALERT'
      | 'TEST'
      | 'APPLICATION_DEPLOYMENT_COMPLETE'
      | 'ENVIRONMENT_CREATE'
      | 'ENVIRONMENT_DELETE'
      | 'ENVIRONMENT_LAUNCH'
      | 'ENVIRONMENT_DESTROY'
      | 'ENVIRONMENT_CONFIGURE',
  ): __Observable<Array<string>> {
    return this.getSubscriptionAttributesUsingGETResponse(
      notificationType,
    ).pipe(__map((_r) => _r.body as Array<string>));
  }

  /**
   * getAllNotificationTypes
   * @return OK
   */
  getAllNotificationTypesUsingGETResponse(): __Observable<
    __StrictHttpResponse<Array<NotificationTypeResponse>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/notification/notificationTypes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<NotificationTypeResponse>>;
      }),
    );
  }
  /**
   * getAllNotificationTypes
   * @return OK
   */
  getAllNotificationTypesUsingGET(): __Observable<
    Array<NotificationTypeResponse>
  > {
    return this.getAllNotificationTypesUsingGETResponse().pipe(
      __map((_r) => _r.body as Array<NotificationTypeResponse>),
    );
  }

  /**
   * getAllSubscriptions
   * @return OK
   */
  getAllSubscriptionsUsingGETResponse(): __Observable<
    __StrictHttpResponse<Array<Subscription>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/notification/subscriptions`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Subscription>>;
      }),
    );
  }
  /**
   * getAllSubscriptions
   * @return OK
   */
  getAllSubscriptionsUsingGET(): __Observable<Array<Subscription>> {
    return this.getAllSubscriptionsUsingGETResponse().pipe(
      __map((_r) => _r.body as Array<Subscription>),
    );
  }

  /**
   * createSubscription
   * @param subscription subscription
   * @return OK
   */
  createSubscriptionUsingPOSTResponse(
    subscription: Subscription,
  ): __Observable<__StrictHttpResponse<Array<Subscription>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = subscription;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/notification/subscriptions`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Subscription>>;
      }),
    );
  }
  /**
   * createSubscription
   * @param subscription subscription
   * @return OK
   */
  createSubscriptionUsingPOST(
    subscription: Subscription,
  ): __Observable<Array<Subscription>> {
    return this.createSubscriptionUsingPOSTResponse(subscription).pipe(
      __map((_r) => _r.body as Array<Subscription>),
    );
  }

  /**
   * getSubscription
   * @param subscriptionId subscriptionId
   * @return OK
   */
  getSubscriptionUsingGETResponse(
    subscriptionId: string,
  ): __Observable<__StrictHttpResponse<Subscription>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/notification/subscriptions/${encodeURIComponent(
          String(subscriptionId),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Subscription>;
      }),
    );
  }
  /**
   * getSubscription
   * @param subscriptionId subscriptionId
   * @return OK
   */
  getSubscriptionUsingGET(subscriptionId: string): __Observable<Subscription> {
    return this.getSubscriptionUsingGETResponse(subscriptionId).pipe(
      __map((_r) => _r.body as Subscription),
    );
  }

  /**
   * editSubscription
   * @param params The `UiNotificationControllerService.EditSubscriptionUsingPUTParams` containing the following parameters:
   *
   * - `subscriptionId`: subscriptionId
   *
   * - `subscription`: subscription
   *
   * @return OK
   */
  editSubscriptionUsingPUTResponse(
    params: UiNotificationControllerService.EditSubscriptionUsingPUTParams,
  ): __Observable<__StrictHttpResponse<Array<Subscription>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.subscription;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/notification/subscriptions/${encodeURIComponent(
          String(params.subscriptionId),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Subscription>>;
      }),
    );
  }
  /**
   * editSubscription
   * @param params The `UiNotificationControllerService.EditSubscriptionUsingPUTParams` containing the following parameters:
   *
   * - `subscriptionId`: subscriptionId
   *
   * - `subscription`: subscription
   *
   * @return OK
   */
  editSubscriptionUsingPUT(
    params: UiNotificationControllerService.EditSubscriptionUsingPUTParams,
  ): __Observable<Array<Subscription>> {
    return this.editSubscriptionUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as Array<Subscription>),
    );
  }

  /**
   * deleteSubscription
   * @param subscriptionId subscriptionId
   * @return OK
   */
  deleteSubscriptionUsingDELETEResponse(
    subscriptionId: string,
  ): __Observable<__StrictHttpResponse<Array<Subscription>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl +
        `/cc-ui/v1/notification/subscriptions/${encodeURIComponent(
          String(subscriptionId),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Subscription>>;
      }),
    );
  }
  /**
   * deleteSubscription
   * @param subscriptionId subscriptionId
   * @return OK
   */
  deleteSubscriptionUsingDELETE(
    subscriptionId: string,
  ): __Observable<Array<Subscription>> {
    return this.deleteSubscriptionUsingDELETEResponse(subscriptionId).pipe(
      __map((_r) => _r.body as Array<Subscription>),
    );
  }

  /**
   * getFiltersForSubscriptions
   * @param params The `UiNotificationControllerService.GetFiltersForSubscriptionsUsingPOSTParams` containing the following parameters:
   *
   * - `tagName`: tagName
   *
   * - `notificationType`: notificationType
   *
   * - `filterParams`: filterParams
   *
   * @return OK
   */
  getFiltersForSubscriptionsUsingPOSTResponse(
    params: UiNotificationControllerService.GetFiltersForSubscriptionsUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<TagDataModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.filterParams;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/notification/${encodeURIComponent(
          String(params.notificationType),
        )}/tag/${encodeURIComponent(String(params.tagName))}/values/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<TagDataModel>;
      }),
    );
  }
  /**
   * getFiltersForSubscriptions
   * @param params The `UiNotificationControllerService.GetFiltersForSubscriptionsUsingPOSTParams` containing the following parameters:
   *
   * - `tagName`: tagName
   *
   * - `notificationType`: notificationType
   *
   * - `filterParams`: filterParams
   *
   * @return OK
   */
  getFiltersForSubscriptionsUsingPOST(
    params: UiNotificationControllerService.GetFiltersForSubscriptionsUsingPOSTParams,
  ): __Observable<TagDataModel> {
    return this.getFiltersForSubscriptionsUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as TagDataModel),
    );
  }

  /**
   * getNotificationTagsForNotificationType
   * @param notificationType notificationType
   * @return OK
   */
  getNotificationTagsForNotificationTypeUsingGETResponse(
    notificationType:
      | 'DEPLOYMENT_STATUS_UPDATE'
      | 'APP_DEPLOYMENT'
      | 'QASUITE_SANITY'
      | 'DR_RESULT'
      | 'STACK_SIGNOFF'
      | 'ALERT'
      | 'TEST'
      | 'APPLICATION_DEPLOYMENT_COMPLETE'
      | 'ENVIRONMENT_CREATE'
      | 'ENVIRONMENT_DELETE'
      | 'ENVIRONMENT_LAUNCH'
      | 'ENVIRONMENT_DESTROY'
      | 'ENVIRONMENT_CONFIGURE',
  ): __Observable<__StrictHttpResponse<Array<NotificationTagsForTypeResult>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/notification/${encodeURIComponent(
          String(notificationType),
        )}/tags`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<NotificationTagsForTypeResult>>;
      }),
    );
  }
  /**
   * getNotificationTagsForNotificationType
   * @param notificationType notificationType
   * @return OK
   */
  getNotificationTagsForNotificationTypeUsingGET(
    notificationType:
      | 'DEPLOYMENT_STATUS_UPDATE'
      | 'APP_DEPLOYMENT'
      | 'QASUITE_SANITY'
      | 'DR_RESULT'
      | 'STACK_SIGNOFF'
      | 'ALERT'
      | 'TEST'
      | 'APPLICATION_DEPLOYMENT_COMPLETE'
      | 'ENVIRONMENT_CREATE'
      | 'ENVIRONMENT_DELETE'
      | 'ENVIRONMENT_LAUNCH'
      | 'ENVIRONMENT_DESTROY'
      | 'ENVIRONMENT_CONFIGURE',
  ): __Observable<Array<NotificationTagsForTypeResult>> {
    return this.getNotificationTagsForNotificationTypeUsingGETResponse(
      notificationType,
    ).pipe(__map((_r) => _r.body as Array<NotificationTagsForTypeResult>));
  }
}

module UiNotificationControllerService {
  /**
   * Parameters for editNotificationChannelUsingPUT
   */
  export interface EditNotificationChannelUsingPUTParams {
    /**
     * nc
     */
    nc: NotificationChannel;

    /**
     * channelId
     */
    channelId: string;
  }

  /**
   * Parameters for editSubscriptionUsingPUT
   */
  export interface EditSubscriptionUsingPUTParams {
    /**
     * subscriptionId
     */
    subscriptionId: string;

    /**
     * subscription
     */
    subscription: Subscription;
  }

  /**
   * Parameters for getFiltersForSubscriptionsUsingPOST
   */
  export interface GetFiltersForSubscriptionsUsingPOSTParams {
    /**
     * tagName
     */
    tagName:
      | 'CLUSTER_NAME'
      | 'CLUSTER_TYPE'
      | 'QASUITE_RESULT'
      | 'DR_ACTION'
      | 'DR_STATUS'
      | 'STACK_NAME'
      | 'SEVERITY'
      | 'ALERT_NAME'
      | 'DEPLOYMENT_STATUS'
      | 'APPLICATION_NAME'
      | 'SEND_RESOLVED'
      | 'RELEASE_TYPE';

    /**
     * notificationType
     */
    notificationType:
      | 'DEPLOYMENT_STATUS_UPDATE'
      | 'APP_DEPLOYMENT'
      | 'QASUITE_SANITY'
      | 'DR_RESULT'
      | 'STACK_SIGNOFF'
      | 'ALERT'
      | 'TEST'
      | 'APPLICATION_DEPLOYMENT_COMPLETE'
      | 'ENVIRONMENT_CREATE'
      | 'ENVIRONMENT_DELETE'
      | 'ENVIRONMENT_LAUNCH'
      | 'ENVIRONMENT_DESTROY'
      | 'ENVIRONMENT_CONFIGURE';

    /**
     * filterParams
     */
    filterParams: { [key: string]: Array<string> };
  }
}

export { UiNotificationControllerService };
